/**
 * Reine, DOM-freie Validierungslogik (im Browser UND in Node testbar).
 * Spiegelt die serverseitige Validierung (backend-php/src/Validator.php).
 * Die serverseitige Pruefung ist und bleibt massgeblich; dies ist Komfort.
 */

/** Spezialschluessel fuer den Either/Or-Fehler (identisch zur Server-Konstante). */
export const IDENT_ERROR_KEY = "ident";

export function isEmail(value) {
  const s = String(value || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s) && s.length <= 254;
}

/**
 * @param {Object} values  key => value
 * @param {Array}  fields   [{key,label,required,type,...}]
 * @param {Array}  identKeys Liste der Either/Or-Keys
 * @returns {Object} errors  key => Meldung (inkl. evtl. IDENT_ERROR_KEY)
 */
export function validateValues(values, fields, identKeys) {
  const errors = {};

  for (const f of fields) {
    if (f.required && String(values[f.key] || "").trim() === "") {
      errors[f.key] = `${f.label} ist erforderlich.`;
    }
  }

  const email = String(values.email || "").trim();
  if (email !== "" && !isEmail(email)) {
    errors.email = "Bitte geben Sie eine gueltige E-Mail-Adresse an.";
  }

  const plz = String(values.plz || "").trim();
  if (plz !== "" && !/^[0-9A-Za-z \-]{3,12}$/.test(plz)) {
    errors.plz = "Bitte geben Sie eine gueltige PLZ an.";
  }

  const hasIdent = (identKeys || []).some(
    (k) => String(values[k] || "").trim() !== ""
  );
  if (!hasIdent) {
    errors[IDENT_ERROR_KEY] =
      "Bitte geben Sie mindestens eines an: Vertrags-/Auftragsnummer ODER " +
      "Immobilie/Adresse ODER Vertragsdatum.";
  }

  return errors;
}

/** True, wenn keine Fehler vorliegen. */
export function isValid(errors) {
  return Object.keys(errors || {}).length === 0;
}
